import { useRecathModal } from "@/hooks/useRecathModal";
import { Box, Stack } from "@chakra-ui/react";
import {
  Button,
  colors,
  getCdnImageSrc,
  Image,
  responsive,
  VStack,
} from "goi_common";
import React from "react";

export default function B2BDisposalServiceSection() {
  const { openModal } = useRecathModal();
  return (
    <VStack
      width="100%"
      alignItems="center"
      background={colors.orange650}
      css={responsive({
        padding: { base: "64px 24px 72px", lg: "80px 0 70px" },
      })}
    >
      <VStack
        maxWidth={`${1200}px`}
        width="100%"
        gap="20px"
        css={responsive({
          alignItems: { base: "center", lg: "flex-start" },
        })}
      >
        <Stack
          css={responsive({
            flexDirection: { base: "column", lg: "row" },
            justifyContent: { base: "center", lg: "space-between" },
            alignItems: { base: "center", lg: "flex-start" },
            width: "100%",
          })}
        >
          <VStack
            css={responsive({
              alignItems: { base: "center", lg: "flex-start" },
            })}
            gap="20px"
          >
            <Box
              className="white head_24_b lg_head_42_b"
              css={responsive({
                textAlign: { base: "center", lg: "left" },
              })}
            >
              일회용품 미리 제작하세요
            </Box>
            <Box
              className="white subtitle_18_r lg_head_28_m"
              css={responsive({
                textAlign: { base: "center", lg: "left" },
              })}
            >
              일회용품 제작하고,
              <br className="lg_over_hidden" /> 기업상조 무료 도입후 제작비용
              돌려받으세요
            </Box>
            <Button
              css={responsive({
                width: "fit-content",
                padding: { base: "14px 22px", lg: "20px 30px" },
                margin: { base: "10px 0", lg: "40px 0" },
                background: colors.brown800,
                color: colors.white,
                borderRadius: "10px",
              })}
              className="subtitle_16_b lg_head_24_b lg_under_hidden"
              onClick={openModal}
            >
              2배 혜택 받기
            </Button>
          </VStack>
          <Box
            css={responsive({
              width: { base: "200px", lg: "300px" },
              height: "auto",
            })}
          >
            <Image
              src={getCdnImageSrc(`b2b/home/funeral-3.png`)}
              width="100%"
              height="auto"
              alt=""
            />
          </Box>
          <Button
            css={responsive({
              width: "fit-content",
              padding: { base: "14px 22px", lg: "20px 30px" },
              marginTop: "40px",
              background: colors.brown800,
              color: colors.white,
              borderRadius: "10px",
            })}
            className="subtitle_16_b lg_head_24_b lg_over_hidden"
            onClick={openModal}
          >
            2배 혜택 받기
          </Button>
        </Stack>
      </VStack>
    </VStack>
  );
}
